import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createScan, submitScan } from "../../../Services/APIs/scan";
import { clearImages } from "../../../Store/fullScan";
import back from "../../../assets/Icons/Back.png";
import close from "../../../assets/Icons/close.png";
import error from "../../../assets/svg/failed.svg";
import SignalAiCaseForm from "./questionnaire";
import { FailedError } from "../ErrorPopups";
import "../signal.css"
import signalLogo from "../../../assets/illustrations/signal-AI.png"
import { steps } from "./steps";
import { postLogDetails } from "../../../Services/APIs/appDetails";

const SubmitPage = () => {
    const navigate = useNavigate();
    const { images } = useSelector((state) => state.fullScan);
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);
    const [activeImageIndex, setActiveImageIndex] = useState(0);
    const [showQuestionnaire, setQuestionnaire] = useState(false)
    const uid = JSON.parse(localStorage.getItem("usertpi") || '{}').usertpi
    const app = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket

    useEffect(() => {
        postLogDetails({ uid, app, payLoad: `Submit page loaded - images captured: ${images.length}` })
    }, [])

    const goBack = () => {
        window.history.back();
    };

    const onSubmitQuestionnaire = (values) => {
        setQuestionnaire(false)
        submitReport()
    }

    const submitReport = async () => {


        try {
            setLoading(true);
            setError(false);

            const info = {
                uid: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
                folderName: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
                company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
                lang: localStorage.getItem("userLanguage") || "en",
            };

            const response = await submitScan(info);

            if (localStorage.getItem("usertpi")) {
                localStorage.setItem(
                    "tpscore",
                    JSON.stringify(response.data?.data?.data)
                );
            }

            const { images, ...mlResults } = response?.data?.data?.data;
            const { pdf_url, name, ...report_score } = mlResults;
            localStorage.setItem("pdf", `${name}.pdf`);

            await createReport({ pdf_url, report_score });
        } catch (error) {
            setLoading(false);
            setError(true);
        }
    };

    const createReport = async (data) => {
        try {
            const tooth = {
                front_teeth: "Front teeth",
                upper_jaw: "Upper jaw",
                lower_jaw: "Lower jaw",
                left_side: "Left side",
                right_side: "Right side",
                face: "Face"
            };

            const report = {
                uid: JSON.parse(localStorage.getItem('usertpi') || "{}").usertpi,
                company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
                is_full_scan: true,
                signal_ai_user_data: JSON.parse(localStorage.getItem("signal_ai_case_form") || "{}"),
                language: localStorage.getItem("userLanguage") || "en",
                ...data
            };

            for (const key in tooth) {
                images.forEach((eachObj) => {
                    if (tooth[key] === eachObj.title) {
                        report[key] = eachObj.file;
                    }
                });
            }

            const response = await createScan(report);
            localStorage.setItem("response", JSON.stringify(response?.data?.data?.report));
            dispatch(clearImages());
            localStorage.setItem("scoreCard", true);
            localStorage.setItem("isScanCompleted", true);
            localStorage.removeItem("reloaded");
            navigate("/signalai_wohd/result", { replace: true });
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError(true);
        }
    };

    const ErrorUI = () => {
        return (
            <div className="h-full z-20 absolute w-full top-0 bg-black/[0.3] backdrop-blur-sm flex justify-center items-center">
                <FailedError
                    onClose={() => setError(false)}
                />
            </div>
        );
    };

    return (
        <div className="h-full relative signal-ai-bg-image">
            {/* {true && < SignalAiCaseForm
            />} */}
            <div className="relative h-full w-full flex flex-col justify-between items-center">
                {isError && <ErrorUI />}



                <div className="w-full">
                    {/* <div className="flex justify-between py-3 px-3">
                        <button type="button" onClick={goBack}>
                            <img src={back} alt="back" className="h-7" />
                        </button>
                        <button type="button" onClick={goBack}>
                            <img src={close} alt="close" className="h-7" />
                        </button>
                    </div> */}
                    <img src={signalLogo} alt="signal-ai" className="w-2/5 mx-auto mt-5" />
                    <p className="text-[34px] text-signal-ai-blue font-medium text-center">
                        သင့်သွားစကန်များ
                    </p>
                </div>

                <div className="w-full flex-1 flex items-center justify-center">
                    {images.length === 0 ? (
                        <p className="text-signal-ai-blue text-center">ပုံများမရှိတ်မည်း</p>
                    ) : (
                        <div className="w-full max-w-md">
                            <div
                                className="flex overflow-x-auto space-x-4 pb-4 scrollbar-thin scrollbar-thumb-gray-300"
                                onScroll={(e) => {
                                    const container = e.target;
                                    const scrollLeft = container.scrollLeft;
                                    const imageWidth = container.children[0]?.offsetWidth || 0;
                                    const spaceBetween = 16; // space-x-4 = 1rem = 16px

                                    if (imageWidth > 0) {
                                        const newIndex = Math.round(scrollLeft / (imageWidth + spaceBetween));
                                        setActiveImageIndex(Math.min(Math.max(newIndex, 0), images.length - 1));
                                    }
                                }}
                            >
                                {images.map((image, index) => (
                                    <div key={index} className="flex-shrink-0 w-3/4 mx-3">
                                        <div className="relative">
                                            <img
                                                src={image.dataUri}
                                                alt={`ပုံ ${index + 1}`}
                                                className="w-full h-48 object-cover rounded-lg shadow-md"
                                            />
                                            <div className="absolute bottom-2 left-2 bg-black/50 text-white px-2 py-1 rounded text-xs">
                                                {steps[index]?.label || `Image ${index + 1}`}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Dot Indicators */}
                            <div className="flex justify-center items-center mt-4 mb-6 space-x-2">
                                {images.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => {
                                            const scrollContainer = document.querySelector('.overflow-x-auto');
                                            const targetImage = scrollContainer.children[index];
                                            if (targetImage) {
                                                targetImage.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                                                setActiveImageIndex(index);
                                            }
                                        }}
                                        className={`transition-all duration-200 rounded-full w-2 h-2`}
                                        style={{
                                            backgroundColor: index === activeImageIndex ? '#0b1971' : 'white',
                                            transform: index === activeImageIndex ? 'scale(1.2)' : 'scale(1)'
                                        }}
                                        aria-label={`Go to image ${index + 1}`}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <button
                    type="button"
                    className="text-white bg-signal-ai-secondary rounded-md px-6 py-3 font-medium  mb-16"
                    onClick={() => setQuestionnaire(true)}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <div className="loader-container my-1">
                            <div className="loader dark-loader"></div>
                        </div>
                    ) : (
                        <span>စစ်ဆေးချက်ရယူမည်</span>
                    )}
                </button>
            </div>
            {showQuestionnaire && <SignalAiCaseForm
                onSubmit={data => onSubmitQuestionnaire(data)}
            />}
        </div>
    );
};

export default SubmitPage;